import { useEffect } from 'preact/hooks';
import { toast } from '../state/store';

export function Toast() {
  const t = toast.value;
  useEffect(() => {
    if (!t) return;
    const h = setTimeout(() => (toast.value = null), 3200);
    return () => clearTimeout(h);
  }, [t?.id]);
  if (!t) return null;
  return (
    <div class="toast" role="status" data-testid="toast">
      {t.text}
    </div>
  );
}
